import apiService from "../../../Services/APIService";
import { checkAPIResponse } from "../../../Utils/APIResponseUtils";

export async function generateWDQR( intgType, provider, configs = [] ) {
	try{
		const payload = {
			changeType : "GENERATE",
			provider: provider,
			intgType : "WD",
			configs: JSON.stringify(configs)
		};
		const result = await apiService.sendChange(14, "setQR", payload);
		checkAPIResponse(result);
		return result;
	}catch(error){
		console.error("generateWDQR API error:", error);
		throw error;
	}
}

export async function sendMessageWD( provider, values = [] ) {
	try{
		const payload = {
			provider: provider,
			values: JSON.stringify(values)
		};

		const result = await apiService.sendChange(14, "sendMessage", payload);
		return result;
	}catch(error){
		console.error("sendMessageWD API error:", error);
		throw error;
	}
}

export async function resetInstanceWD( intgType, provider, configs = [] ){
	try{
		const payload = {
			changeType : "RESET",
			provider : provider,
			intgType : "WD",
			configs : JSON.stringify(configs)
		};

		const result = await apiService.sendChange(14, "reset", payload);
		return result;
	}catch(error){
		console.error("resetInstanceWD API error:", error);
		throw error;
	}
}

export async function checkStatusWD( intgType, provider, configs = [] ){
	try{
		const payload = {
			intgType : intgType,
			changeType : "SET",
			provider : provider,
			configs : JSON.stringify(configs)
		};

		const result = await apiService.sendChange(14, "setStatus", payload);
		return result;
		
	}catch(error){
		console.error("checkStatusWD API error:", error);
		throw error;
	}
}